var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    {
      staticClass: "root",
      class: { "sm-down": _vm.$wf.isSmDown },
      attrs: { "max-width": "900" },
    },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("green-book")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _vm.$wf.isSmDown
        ? _c("app-purchase-info-ledgers-mobile", {
            attrs: { purchase: _vm.purchase },
          })
        : _c("app-purchase-info-ledgers", {
            attrs: { purchase: _vm.purchase },
          }),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("w-col", { attrs: { xs: "12" } }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$ct("total-booked", { value: _vm.totalBooked })
                    ) +
                    " "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }